import React from 'react';
import styled from 'styled-components';
import {color} from '@ey/styled-theme';
import Utility from '../../../util/utilityfunctions';
import Badge from '../Badge/Badge';
import PropTypes from 'prop-types';

function CellItem(props) {
	const {column, cellType, rowData, groupHeaderLabel, className} = props;

	const getCellTemplate = (column, rowData) => {
		let template = null;

		if (cellType == 'GroupCell' || cellType == 'GroupHeaderCell') {
			return getGroupItemTemplate(cellType);
		}

		return template;
	};

	const getGroupItemTemplate = (cellType) => {
		return (
			<>
				<span title={groupHeaderLabel} className={`${cellType} accordion-title ellipsis`}>
					{groupHeaderLabel}
				</span>
				{subHeaderLabel && (
					<span title={subHeaderLabel} className={`${cellType} accordion-title ellipsis`}>
						<br />
						{subHeaderLabel}
					</span>
				)}
			</>
		);
	};

	const getHeaderItemTemplate = () => {
		return (
			<>
				<span title={column.columnHeaderDisplayName} className="header-name ellipsis">
					{column.displayName}
				</span>
				{count > 0 && (
					<span className={'column-countbadge'}>
						{' '}
						<Badge variantOptions="alt" count={count} />{' '}
					</span>
				)}
			</>
		);
	};

	return (
		<StyledCellItemContainer className={`group-cell-wrap column-header ${className ? className : ''}`}>
			{getCellTemplate(column, rowData)}
		</StyledCellItemContainer>
	);
}

CellItem.propTypes = {
	cellType: PropTypes.string.isRequired
};

export default CellItem;

const StyledCellItemContainer = styled.span``;
